import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import ChannelService from "../../../services/KangarooServices/Intelligence/ChannelService";
import DestinationService from "../../../services/KangarooServices/DestinationService";
import toast from "react-hot-toast";
import { imageBaseApi } from "../../../utilis/imageHelper";

const AssignInstitutes = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [institutes, setInstitutes] = useState([]);
  const [selectedInstitutes, setSelectedInstitutes] = useState([]);
  const [destinationName, setDestinationName] = useState("");

  const [searchText, setSearchText] = useState("");

  const filteredInstitutes = institutes.filter((inst) =>
    inst.name.toLowerCase().includes(searchText.toLowerCase()),
  );

  //This is for if want to preselect already assigned institutes
  const loadInstitutes = async () => {
    try {
      const channelPartner = await ChannelService.getdetails(id);

      if (!channelPartner?.destinationCountryId) {
        toast.error("Destination country not found");
        return;
      }

      setDestinationName(channelPartner.destinationCountryName);

      //institutes of destination country
      const destination = await DestinationService.getDetail(
        channelPartner.destinationCountryId,
      );

      const destinationInstitutes = destination?.universities || [];
      setInstitutes(destinationInstitutes);

      //This selects the  already assigned institutes
      if (channelPartner?.universities?.length) {
        const preSelected = channelPartner.universities
          .map((assigned) =>
            destinationInstitutes.find((inst) => inst.id === assigned.id),
          )
          .filter(Boolean); // removes undefined if any mismatch

        setSelectedInstitutes(preSelected);
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to load institutions");
    }
  };

  useEffect(() => {
    loadInstitutes();
  }, []);

  const toggleInstitute = (inst) => {
    setSelectedInstitutes((prev) =>
      prev.some((i) => i.id === inst.id)
        ? prev.filter((i) => i.id !== inst.id)
        : [...prev, inst],
    );
  };

  const removeInstitute = (id) => {
    setSelectedInstitutes((prev) => prev.filter((inst) => inst.id !== id));
  };

  const isSelected = (inst) => selectedInstitutes.some((i) => i.id === inst.id);

  const handleAssign = async () => {
    if (!selectedInstitutes.length) {
      toast.error("Select at least one institute");
      return;
    }

    const payload = {
      channelPartnerId: id,
      universityIds: selectedInstitutes.map((u) => u.id),
      orderIndex: 0,
    };

    try {
      await ChannelService.createAssignUni(payload);
      toast.success("Institutes assigned successfully");
      navigate("/channel-partners");
    } catch (error) {
      toast.error("Assignment failed");
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Assign Institutes"
          pageTitle="Channel Partner"
          breadcrumbItems={[
            { title: "Back to List", link: "/channel-partners" },
          ]}
        />

        <Row className="mb-3">
          <Col md={6}>
            <input
              type="text"
              className="form-control"
              placeholder="Search institutes..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </Col>

          <Col className="text-end">
            <div className="d-flex gap-2 justify-content-end">
              <Button
                size="sm"
                color="info"
                onClick={() => navigate(`/reorder-institute/${id}`)}
              >
                Reorder
              </Button>
              <Button
                color="danger"
                onClick={() => navigate(`/unassign-institute/${id}`)}
              >
                Unassign
              </Button>

              <Button color="success" onClick={handleAssign}>
                Assign
              </Button>
            </div>
          </Col>
        </Row>
        {selectedInstitutes.length > 0 && (
          <Row className="mb-3">
            <Col>
              <div className="p-2 bg-light rounded d-flex flex-wrap align-items-center">
                <strong className="me-2">Selected Institutes:</strong>

                {selectedInstitutes.map((inst) => (
                  <span
                    key={inst.id}
                    className="badge bg-primary me-2 mb-1 d-flex align-items-center"
                    style={{ fontSize: "0.85rem" }}
                  >
                    {inst.name}
                    <span
                      className="ms-2"
                      style={{
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                      onClick={() => removeInstitute(inst.id)}
                    >
                      ×
                    </span>
                  </span>
                ))}
              </div>
            </Col>
          </Row>
        )}

        <Row className="g-3">
          {filteredInstitutes.map((inst) => (
            <Col xl={2} lg={3} md={4} sm={6} key={inst.id}>
              <Card
                onClick={() => toggleInstitute(inst)}
                className={`h-100 text-center ${
                  isSelected(inst) ? "border border-primary shadow" : ""
                }`}
                style={{ cursor: "pointer", borderRadius: "10px" }}
              >
                <CardBody>
                  <img
                    src={`${imageBaseApi}${inst.logo?.url}`}
                    alt={inst.name}
                    style={{
                      maxHeight: "80px",
                      objectFit: "contain",
                    }}
                    className="img-fluid mb-2"
                  />
                  <h6 className="mb-0 text-truncate">{inst.name}</h6>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default AssignInstitutes;
